import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { IBannerImageListDataModel } from '../../models/banner-image-list.datamodel';
import { ModelService } from '../../services/model.service';
import { JssStylingService } from '../../jss-styling.service';

@Component({
  selector: 'app-banner-image-list-gallery',
  templateUrl: './banner-image-list-gallery.component.html',
  styleUrls: ['./banner-image-list-gallery.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BannerImageListGalleryComponent implements OnInit {
  @Input() rendering: ComponentRendering;
  public containerClass: string = "pb-gallery--true";
  public cards: IBannerImageListDataModel[] = [];
  dynamicClass: string;

  constructor(private modelService: ModelService, public jssStylingService: JssStylingService) { }

  ngOnInit() {
    // remove this after implementation is done
    this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);
    let fields = this.rendering.fields as any;
    if (fields) {
      if(fields?.Position?.value == 'left'){
        this.containerClass = "pb-gallery--false";
      }
    }
    if(fields?.Cards?.length > 0){
      fields?.Cards.forEach((item: any) => {
        let data = this.modelService.getBannerImageList(item.fields);
        this.cards.push(data);
      });
    }
  }
}
